import type { ComplianceColorBand } from '@/shared/types/SharedProps'
import { complianceBgColor, formatCompliancePercent } from '@/shared/lib/compliance'

interface ComplianceBadgeProps {
  percent: number | null | undefined
  windowDays?: number | null
  colorCodes?: ComplianceColorBand[] | null
}

export function ComplianceBadge({ percent, windowDays, colorCodes }: ComplianceBadgeProps) {
  if (percent == null) return <span className="text-muted-foreground">—</span>

  const bg = complianceBgColor(percent, colorCodes)
  const label = windowDays ? `Last ${windowDays} Days · ` : ''

  return (
    <span
      className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium text-gray-800"
      style={{ backgroundColor: bg }}
    >
      {label}
      {formatCompliancePercent(percent)}
    </span>
  )
}
